module.exports = __webpack_public_path__ + "static/img/1_11_2.ca56c50a.jpg";